import Ajax from '@utils/ajax';

export default {
  create(data, options = {}) {
    return Ajax.post({
      url: `/users/create_user`,
      data: data,
      ...options,
    });
  },

  checkEmail: function (email, options = {}) {
    return Ajax.get({
      url: `/users/check_email`,
      data: { email: email },
      ...options,
    });
  },

  checkUsername: function (username, options = {}) {
    return Ajax.get({
      url: `/users/check_username`,
      data: { username: username },
      ...options,
    });
  },

  get(id, options = {}) {
    return Ajax.get({
      url: `/users/${id}`,
      ...options,
    });
  },

  getStrict(id, options = {}) {
    return Ajax.get({
      url: `/users/${id}?strict=1`,
      ...options,
    });
  },

  getOg(id, options = {}) {
    return Ajax.get({
      url: `/users/${id}/og`,
      ...options,
    });
  },

  update(user, data, options = {}) {
    return Ajax.post({
      url: `/users/${user.id}`,
      data: { user: data, _method: 'PATCH' },
      ...options,
    });
  },

  updatePassword(user, data) {
    return Ajax.post({
      url: `/users/${user.id}/update_password`,
      data: data,
    });
  },

  updateEmail(email) {
    return Ajax.post({
      url: `/users/me/update_email`,
      data: { email: email },
    });
  },

  enableCashback(user) {
    return Ajax.post({
      url: `/users/${user.id}/enable_cashback`,
    });
  },

  updateNotificationSettings(data) {
    return Ajax.post({
      url: `/users/me/notification_settings`,
      data: { notification_settings: data, _method: 'PATCH' },
    });
  },

  markAsNeedsOnboardingMobileApp() {
    return Ajax.post({
      url: `/users/mark_as_needs_onboarding_mobile_app`,
    });
  },

  getNotificationSettings() {
    return Ajax.get({
      url: `/users/me/notification_settings`,
    });
  },

  recentViewers(last_id) {
    return Ajax.get({
      url: `/dashboard/recent_viewers`,
      data: { last_id: last_id },
    });
  },

  transactionHistory(last_ts) {
    return Ajax.get({
      url: `/dashboard/transaction_history`,
      data: { last_ts: last_ts },
    });
  },

  invitePageSeen(user) {
    return Ajax.post({
      url: `/users/${user.id}/invite_page_seen`,
    });
  },

  markVerificationRequestNudgeSeen(user) {
    return Ajax.post({
      url: `/users/${user.id}/mark_verification_request_nudge_seen`,
    });
  },

  setProfileMenuClicked(user) {
    return Ajax.post({
      url: `/users/${user.id}/set_profile_menu_clicked`,
    });
  },

  searchGroups(user, query, offset) {
    return Ajax.get({
      url: `/users/${user.id}/search_groups`,
      data: { query: query, offset: offset },
    });
  },

  searchRecs(user, query, offset) {
    return Ajax.get({
      url: `/users/${user.id}/search_recs`,
      data: { query: query, offset: offset },
    });
  },

  searchUsers(query, offset, groupId = null) {
    let data = { query: query, offset: offset };
    if (groupId) {
      data['group_base_id'] = groupId;
    }
    return Ajax.get({
      url: `/users/search_users`,
      data: data,
    });
  },

  follow_counts(user) {
    return Ajax.get({
      url: `/users/${user.username}/follow_counts`,
    });
  },

  follow(user) {
    return Ajax.post({
      url: `/users/${user.username}/follow`,
    });
  },

  unfollow(user) {
    return Ajax.post({
      url: `/users/${user.username}/unfollow`,
    });
  },

  following(user, page) {
    return Ajax.get({
      url: `/users/${user.username}/following?page=${page}`,
    });
  },

  followers(user, page) {
    return Ajax.get({
      url: `/users/${user.username}/followers?page=${page}`,
    });
  },

  requestVerification() {
    return Ajax.post({
      url: `/users/me/verification_request`,
    });
  },

  bonusTier() {
    return Ajax.get({
      url: `/users/me/bonus_tier`,
    });
  },

  presignedUrl() {
    return Ajax.get({
      url: `/users/me/presigned_url`,
    });
  },

  paidCollaboration() {
    return Ajax.get({
      url: `/users/me/paid_collaboration`,
    });
  },

  invitedUsers(page) {
    return Ajax.get({
      url: `/users/me/invited_users?page=${page}`,
    });
  },

  suggestedReferrals() {
    return Ajax.get({
      url: `/user_suggested_referrals`,
    });
  },

  updateSuggestedReferral(referralId, status) {
    return Ajax.post({
      url: `/user_suggested_referrals/${referralId}`,
      data: { user_suggested_referral: { status: status }, _method: 'PATCH' },
    });
  },

  generateQuiz(data, options = {}) {
    return Ajax.post({
      url: `/users/generate_quiz`,
      data: data,
      ...options,
    });
  },

  generatePossibleGroupIdeas(options = {}) {
    return Ajax.post({
      url: `/users/generate_possible_group_ideas`,
      ...options,
    });
  },
};
